class SiteInfoRequest{
    SiteInfoURL(){
        return process.env.REACT_APP_BASEURL+"SiteInfo"
    }
}
export const {SiteInfoURL}=new SiteInfoRequest();